// Gutenberg block: labify/comparison (frontend placeholder).
(() => {
  const el = document.querySelector(".wp-block-labify-comparison, .the__comparison, .c-comparison");
  if (!el) return;
})();

